import type React from 'react'

import { ButtonBase } from '@components/ui/Buttons'

export interface CollapseControlButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  contentId: string
  isExpanded?: boolean
}

export function CollapseControlButton({ contentId, isExpanded = false, ...rest }: CollapseControlButtonProps) {
  return <ButtonBase aria-expanded={isExpanded} aria-controls={contentId} {...rest} />
}
